import { ClaimEventResponseItem, getClaimEventByNumber } from 'API';
import { CustomMetaTitle, LinkArrowLeft2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { HeaderInfo } from 'Modules/Status/HeaderInfo';
import { NoDataClaims } from 'Modules/Status/NoDataClaims';
import { SingleClaimEvent } from 'Modules/Status/SingleClaimEvent';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';

export const SingleStatus = () => {
  const { isLoading, setIsLoading, loader } = useLoader();
  const [claimEvent, setClaimEvent] = useState<ClaimEventResponseItem | null>(
    null
  );

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const { claimEventNumber } = useParams();

  const initSingleClaimEvent = useCallback(async () => {
    setIsLoading(true);
    if (!claimEventNumber) return;
    const claimEvent = await getClaimEventByNumber(claimEventNumber.toString());
    if (claimEvent) setClaimEvent(claimEvent);
    setIsLoading(false);
  }, [claimEventNumber, setIsLoading]);

  useEffect(() => {
    initSingleClaimEvent();
  }, [initSingleClaimEvent, imposterId]);

  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.Status].pageTitle} />
      <LinkArrowLeft2
        text={Dictionary[DICTIONARY.CompassRights].entitlements.lastPage}
        href='/recognitionStatus'
        newWindow={false}
        sx={{ flexDirection: 'row-reverse' }}
        imgSx={{ transform: 'rotate(0)' }}
      />
      {isLoading ? (
        loader
      ) : claimEvent ? (
        <>
          <HeaderInfo />
          <SingleClaimEvent claimEvent={claimEvent} />
        </>
      ) : (
        <NoDataClaims />
      )}
    </>
  );
};
